document.addEventListener('DOMContentLoaded', function () {
  const url = 'https://app.alyvewellness.com/api/proxy_get_latest_questionnaire';

  // Build payload as plain JS object
  const payload = {
    // shopify_id: 23163418640768,
    tokenId: 23163418640768,
    // completed: 1,
    // _sort: 'created_at:DESC',
    // skip: 3,
    // _limit: 3
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-customer-email': 'waqasmalik10@hotmail.com',
      'x-customer-id': '23163418640768',
      'x-customer-signature': 'be9481c09aa2e9bd9f32ff11f6755d64f3b4bef8b7bd245fe5eff1d623ca574a',
      'x-shopify-shop-domain': 'alyve-store.myshopify.com'
    },
    body: JSON.stringify(payload) 
  })
    .then(async (response) => {
      const text = await response.text();
      console.log('Status:', response.status);
      console.log('Body:', text);
      if (!response.ok) throw new Error(text);
    })
    .then(data => console.log('✅ API Response:', data))
    .catch(error => console.error('❌ API Request Failed:', error));
});


document.addEventListener('DOMContentLoaded', function () {
  const url = 'https://app.alyvewellness.com/api/proxy_get_completed_questionnaire';

  // Build payload as plain JS object
  const payload = {
    // shopify_id: 23163418640768,
    tokenId: 23163418640768,
    // completed: 1,
    // _sort: 'created_at:DESC',
    skip: 3,
    _limit: 3
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-customer-email': 'waqasmalik10@hotmail.com',
      'x-customer-id': '23163418640768',
      'x-customer-signature': 'be9481c09aa2e9bd9f32ff11f6755d64f3b4bef8b7bd245fe5eff1d623ca574a',
      'x-shopify-shop-domain': 'alyve-store.myshopify.com'
    },
    body: JSON.stringify(payload) 
  })
    .then(async (response) => {
      const text = await response.text();
      console.log('Status:', response.status);
      console.log('Body:', text);
      if (!response.ok) throw new Error(text);
    })
    .then(data => console.log('✅ API Response:', data))
    .catch(error => console.error('❌ API Request Failed:', error));
});



document.addEventListener('DOMContentLoaded', function () {
  const url = 'https://app.alyvewellness.com/api/proxy_get_latest_questionnaire?isActive=true';

  // Build payload as plain JS object
  const payload = {
    // shopify_id: 23163418640768,
    tokenId: 23163418640768,
    // completed: 1,
    // _sort: 'created_at:DESC',
    // skip: 3,
    // _limit: 3
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-customer-email': 'waqasmalik10@hotmail.com',
      'x-customer-id': '23163418640768',
      'x-customer-signature': 'be9481c09aa2e9bd9f32ff11f6755d64f3b4bef8b7bd245fe5eff1d623ca574a',
      'x-shopify-shop-domain': 'alyve-store.myshopify.com'
    },
    body: JSON.stringify(payload) 
  })
    .then(async (response) => {
      const text = await response.text();
      console.log('Status:', response.status);
      console.log('Body:', text);
      if (!response.ok) throw new Error(text);
    })
    .then(data => console.log('✅ API Response:', data))
    .catch(error => console.error('❌ API Request Failed:', error));
});

